import * as React from "react"
import { type VTableEmptyBodyProps } from "@digits-shared/components/UI/VirtualizedTable/vTableTypes"
import { Tbody, Td } from "@digits-shared/DesignSystem/Tables/tableStyles"
import styled from "styled-components"

const EmptyTd = styled(Td)`
  text-align: center;
`

/*
  COMPONENTS
*/
export const VTableEmptyBody = <TData extends object>({
  table,
  EmptyTable,
}: VTableEmptyBodyProps<TData>) => (
  <Tbody inert>
    <tr>
      <EmptyTd colSpan={table.getVisibleLeafColumns().length}>
        {EmptyTable ? <EmptyTable /> : <b>No Data</b>}
      </EmptyTd>
    </tr>
  </Tbody>
)
